
import { axios_requer } from '../axios/http_axios'


// 参数有这些,需要的就填,不写就用默认值

// path,
// params = {},
// method = 'POST',  //  POST / GET
// headerType = '',  //   json 和 "" 两种
// isShowLoading = true,  //是否显示加载中
// istips = true,        //是否弹窗
// hasSing = false,      //是否有签名

let method = 'GET' //需要GET请求的加上这个
let headerType = 'json'

export default {
    // 获取报销单打印数据
    async getExpensePrintData(params) {
        return await axios_requer({
            path: 'v3/admin/print/data/getExpensePrintData',
            params,
            headerType,
        }).then(res => res);
    },
    // 获取荣祥运单打印数据
    async getWaybillRxPrintData(params) {
        return await axios_requer({
            path: '/v3/admin/print/data/getWaybillRxPrintData',
            params,
            headerType,
        }).then(res => res);
    },
    // 获取费用报销单-发车单明细打印数据
    async getExpenseDispatchPrintData(params) {
        return await axios_requer({
            path: "/v3/admin/print/data/getExpenseDispatchPrintData",
            params,
            headerType
        }).then(res => res);
    },
    // 获取费用报销单-外发单打印数据 expenseIds
    async getExpenseOutgoingPrintData(params) {
        return await axios_requer({
            path: "/v3/admin/print/data/getExpenseOutgoingPrintData",
            params,
            headerType
        }).then(res => res);
    },
    // 获取费用报销单-运单应付明细打印数据  expenseIds
    async getExpenseWaybillFinanceOutPrintData(params) {
        return await axios_requer({
            path: "/v3/admin/print/data/getExpenseWaybillFinanceOutPrintData",
            params,
            headerType
        }).then(res => res);
    },
    // 获取打印模板列表
    async getPrintModelList(params) {
        return await axios_requer({
            path: "/common/v3/print/model/getPrintModelList",
            params,
            method
        }).then(res => res);
    },
    // 获取打印字段
    async getPrintFields(params) {
        return await axios_requer({
            path: "/v3/admin/print/data/getPrintFields",
            params,
            method
        }).then(res => res);
    },
    // 获取打印数据
    async getOutgoingPrintData(params) {
        return await axios_requer({
            path: "/v3/admin/print/data/getOutgoingPrintData",
            params,
            headerType
        }).then(res => res);
    },

    // 保存打印模板
    async savePrintModel(params) {
        return await axios_requer({
            path: "/common/v3/print/model/savePrintModel",
            params
        }).then(res => res);
    },
    // 获取外发单标签打印数据
    async getOutgoingTabPrintData(params) {
        return await axios_requer({
            path: "/v3/admin/print/data/getOutgoingTabPrintData",
            params,
            headerType
        }).then(res => res);
    },
    // 删除打印模板
    async delPrintModel(params) {
        return await axios_requer({
            path: "/common/v3/print/model/delPrintModel",
            params
        }).then(res => res);
    },



    // 车辆成本
    // 获取车辆成本打印数据
    async getCarCostPrintData(params) {
        return await axios_requer({
            path: "/v3/admin/print/data/getCarCostPrintData",
            params,
            headerType
        }).then(res => res);
    },

    // 获取发车配载清单
    async getDispatchPrintData(params) {
        return await axios_requer({
            path: "/v3/admin/print/data/getDispatchPrintData",
            params,
            headerType
        }).then(res => res);
    },

    // 获取费用报销-单条(其他支出)
    // com.bami.service.tms.v3.admin.print.vo.AdminOtherFinanceOnePrintDataV3tmsVo
    async getOtherFinanceOnePrintData(params) {
        return await axios_requer({
            path: "/v3/admin/print/data/getOtherFinanceOnePrintData",
            params,
            headerType
        }).then(res => res);
    },

    // 获取费用报销-多条(其他支出)
    // com.bami.service.tms.v3.admin.print.vo.AdminOtherFinanceMorePrintDataV3tmsVo
    async getOtherFinanceMorePrintData(params) {
        return await axios_requer({
            path: "/v3/admin/print/data/getOtherFinanceMorePrintData",
            params,
            headerType
        }).then(res => res);
    },



}
